module.exports = __webpack_public_path__ + "static/media/sbf-website-view-3.5a6d04ab.png";